import { isValid, parseISO } from 'date-fns';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';

export const isValidDepartureDate = (
    departureDate: string,
    hrSimulation: HrSimulation,
): boolean =>
    isValid(parseISO(departureDate)) &&
    departureDate >= hrSimulation.startDate &&
    departureDate <= hrSimulation.endDate;
